package com.nonopn.skywatcher.common.app.navigation

import com.nonopn.skywatcher.common.login.pages.RouterMain
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.Router

object PossibleRoutes {
    val entriesDetectionSelected: List<Router<*>> = listOf(
        RouterDetection,
        RouterUsers,
        RouterUsersScanQr,
        RouterAdministrators,
        RouterAdministratorsScanQr,
    )
    val entriesNoDetectionSelected: List<Router<*>> = listOf(
        RouterProfile,
        RouterNoThunderDetectionSelected
    )

    /**
     * Entries in expected order of importance
     * Detection can be detected as /sentinel/{uuid} hence before Main because / would match
     */
    val entries: List<Router<*>> = listOf(
        RouterProfile,
        RouterUsers,
        RouterUsersScanQr,
        RouterAdministratorsScanQr,
        RouterAdministrators,
        RouterDetection,
        RouterNoThunderDetectionSelected,
    )

    fun defaultFromUrlLaunched(path: String): RouteParameterTo =
        (entries.firstOrNull { it.isMatching(path) } ?: RouterMain).navigateFrom(path)
}
